import { Interval, DateTime } from 'luxon';

/**
 * map postgresql time range to date type
 * date range looks like '["2019-09-23 04:30:00-04","2019-09-23 07:00:00-04")'
 */
export function mapPostgresTimeRange(timeRange: string): Interval {
  const [startDate, endDate] = timeRange
    .replace(/[[)"]/gi, '')
    .split(',')
    .map(str => DateTime.fromSQL(str));

  return Interval.fromDateTimes(startDate, endDate);
}
